import React from "react";
import { useNavigate } from "react-router-dom";

function AuthModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>✕</button>
        
        <div className="modal-icon">🔐</div>
        <h3 className="modal-title">توجه</h3>
        <p className="modal-message">
          کاربر گرامی شما قبل از انجام این معامله باید در سامانه ما ثبت نام کرده و احراز هویت کنید
        </p>
        <p className="modal-submessage">با تشکر</p>
        
        <div className="modal-buttons">
          <button 
            className="modal-btn modal-btn-primary"
            onClick={() => { onClose(); navigate("/register"); }}
          >
            📝 ثبت‌نام
          </button>
          <button 
            className="modal-btn modal-btn-secondary"
            onClick={() => { onClose(); navigate("/loginpage"); }}
          >
            🔑 ورود
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuthModal;